var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "password-modal as-flex flex-vertical main-start cross-center",
    },
    [
      _c(
        "div",
        { staticClass: "indicator-title as-flex main-center cross-center f-4" },
        [
          _c("div", { staticClass: "title-center" }, [
            _vm._v(
              _vm._s(
                _vm.defaultConfig.type === "change" ? "修改密码" : "重置密码"
              )
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "title-close", on: { click: _vm.close } }, [
            _c("img", {
              attrs: {
                src: require("../../assets/images/close-3x.png"),
                height: "100%",
                width: "100%",
              },
            }),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "indicator-content as-flex flex-vertical main-start cross-center",
        },
        [
          _c(
            "div",
            { staticClass: "mobile-row as-flex main-start cross-center" },
            [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.mobile,
                    expression: "mobile",
                  },
                ],
                attrs: { type: "text", placeholder: "请输入手机号" },
                domProps: { value: _vm.mobile },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.mobile = $event.target.value
                  },
                },
              }),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "validation-row as-flex main-start cross-center" },
            [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.code,
                    expression: "code",
                  },
                ],
                attrs: { type: "text", placeholder: "短信验证码" },
                domProps: { value: _vm.code },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.code = $event.target.value
                  },
                },
              }),
              _vm._v(" "),
              _c(
                "div",
                {
                  class: [
                    "getValidationCode",
                    "as-flex",
                    "main-center",
                    "cross-center",
                    "f-1",
                    _vm.countDown ? "is-counting" : "",
                  ],
                  on: { click: _vm.getCode },
                },
                [
                  _vm._v(
                    _vm._s(
                      _vm.countDown ? _vm.countDown + "s后重发" : "获取验证码"
                    )
                  ),
                ]
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "mobile-row as-flex main-start cross-center" },
            [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.passwd,
                    expression: "passwd",
                  },
                ],
                attrs: { type: "password", placeholder: "请输入新密码" },
                domProps: { value: _vm.passwd },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.passwd = $event.target.value
                  },
                },
              }),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "mobile-row as-flex main-start cross-center" },
            [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.passwd_repeat,
                    expression: "passwd_repeat",
                  },
                ],
                attrs: { type: "password", placeholder: "请再次输入新密码" },
                domProps: { value: _vm.passwd_repeat },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.passwd_repeat = $event.target.value
                  },
                },
              }),
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "error f-1" }, [_vm._v(_vm._s(_vm.error))]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "confirm-btn as-flex main-center cross-center f-3",
              on: { click: _vm.confirm },
            },
            [_vm._v("确定")]
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }